module.exports = __webpack_public_path__ + "static/media/club-5.32d1266f.png";